import { createSignal, onCleanup, onMount } from 'solid-js'

/**
 * True en móvil (ancho < 640px, el breakpoint `sm` de Tailwind). La UI usa este
 * umbral para decidir entre la tabla y las vistas de tarjetas deslizables.
 */
export function useIsMobile(): () => boolean {
  const [isMobile, setIsMobile] = createSignal(false)

  onMount(() => {
    const mq = window.matchMedia('(max-width: 639px)')
    const update = () => setIsMobile(mq.matches)
    update()
    mq.addEventListener('change', update)
    onCleanup(() => mq.removeEventListener('change', update))
  })

  return isMobile
}
